<template>
    <div class="warranty-repair-box">
        <div class="card">
            <div class="card-body">
                <h3>Service Center</h3>
                <p>
                    If you are experiencing any problems with your Dewhot Product please log a warranty claim. Make sure you read the warranty
                    <a href="https://dewhot.co.za/warranty-terms/" target="_blank">terms and conditions</a>
                </p>

                <div class="mb-5">
                    <div
                        v-if="(getUserRole === 'superadmin' || getUserRole === 'distributor') && ticket_status == 'request'"
                        class="alert alert-info"
                        role="alert"
                    >
                        User has requested a warranty claim.
                    </div>

                    <template v-if="getUserRole === 'superadmin' || getUserRole === 'distributor'">
                        <div v-if="ticket_status === 'request'">
                            <button class="btn btn-secondary rounded mb-3 mr-2" @click="updateAction('open')">Accept</button>
                            <button class="btn btn-primary rounded mb-3 mr-2" @click="updateAction('decline')">Decline</button>
                            <button v-if="ticket_type != 'repair'" class="btn btn-secondary rounded mb-3" @click="updateAction('repair')">
                                Repair
                            </button>
                            <button v-else class="btn btn-secondary rounded mb-3" @click="updateAction('warranty')">Warrantty Claim</button>
                        </div>
                    </template>
                </div>

                <!-- <pre>{{ tickets }}</pre> -->
                <h3 class="claim-heading" v-if="tickets.length > 0">DETAILS:</h3>

                <div class="ticket-message-list" id="display_messages" v-if="tickets.length > 0">
                    <div class="chat-ticket-group" v-bind:key="'ticket_superadmin' + ticket.id + ticket.reg_product_sn" v-for="ticket in tickets">
                        <span class="pl-3"
                            ><strong> Ticket# : {{ ticket.id }}</strong>
                        </span>
                        <ul
                            :class="'chat-list ' + msg.type"
                            v-bind:key="'ticket_superadmin' + ticket.id + ticket.reg_product_sn + msg.id"
                            v-for="msg in ticket.messages"
                        >
                            <li v-if="msg.type === 'request'" class="chat-closed chat-new-request">
                                <div>{{ msg.message }} at {{ readAbleTime(msg.created_at) }} by {{ msg.by_user_name }}</div>
                            </li>

                            <li v-else-if="msg.type === 'open'" class="chat-closed chat-new-request-approved">
                                <div>{{ msg.message }} at {{ readAbleTime(msg.created_at) }} by {{ msg.by_user_name }}</div>
                            </li>

                            <li v-else-if="msg.type === ''" :class="vg_loggedIn_user_id == msg.by_user_id ? 'myquestion' : 'helpdesk '">
                                <div class="">
                                    <div class="chat-attachment-wrap" v-if="msg.attachment_url">
                                        <template v-if="msg.attachment_type == 'video' || msg.attachment_type == 'video/mp4'">
                                            <div class="chat-video">
                                                <video class="video-attachment" controls>
                                                    <source :src="msg.attachment_url" type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        </template>

                                        <template
                                            v-if="
                                                msg.attachment_type == 'image/png' ||
                                                msg.attachment_type == 'image/jpg' ||
                                                msg.attachment_type == 'image/jepg' ||
                                                msg.attachment_type == 'image/jpeg' ||
                                                msg.attachment_type == 'jpeg' ||
                                                msg.attachment_type == 'png' ||
                                                msg.attachment_type == 'jpg' ||
                                                msg.attachment_type == 'jepg' ||
                                                msg.attachment_type == 'image'
                                            "
                                        >
                                            <div class="chat-image mb-2" @click.prevent="openImageModal(msg.attachment_url)">
                                                <img :src="msg.attachment_url" class="image-attachment" />
                                            </div>
                                        </template>
                                        <template v-if="msg.attachment_type == 'application/pdf' || msg.attachment_type == 'pdf'">
                                            <a class="chat-attachment text-dark" :href="msg.attachment_url" target="_blank">
                                                <i class="fas fa-file-pdf"></i> View Pdf Attachment
                                            </a>
                                        </template>
                                    </div>
                                    {{ msg.message }}
                                    <span class="time"> {{ msg.by_user_name }}</span>
                                </div>
                            </li>

                            <li v-if="msg.type === 'approved'" class="chat-closed chat-new-request-approved">
                                <div>{{ msg.message }} at {{ readAbleTime(msg.created_at) }} by {{ msg.by_user_name }}</div>
                            </li>

                            <li v-else-if="msg.type === 'rejected'" class="chat-closed chat-new-request-approved">
                                <div>{{ msg.message }} at {{ readAbleTime(msg.created_at) }} by {{ msg.by_user_name }}</div>
                            </li>
                            <li v-else-if="msg.type === 'closed'" class="chat-closed">
                                <div>Ticket closed at {{ readAbleTime(msg.created_at) }} by {{ msg.by_user_name }}</div>
                                <p>
                                    {{ msg.message }}
                                    <a v-if="msg.attachment_url" :href="msg.attachment_url" target="_blank" class="text-royalblue text-sm"
                                        >View Attachment</a
                                    >
                                </p>

                                <div v-if="ticket.repaired_materials.length > 0" class="repaired-history-wrapper">
                                    <p>
                                        <strong>Job card:</strong>
                                        <a
                                            class="ml-2 text-white"
                                            target="_blank"
                                            v-if="ticket.repaired_materials[0].job_card"
                                            :href="ticket.repaired_materials[0].job_card"
                                            >View</a
                                        >
                                        <span v-else>-</span>
                                    </p>
                                    <p>
                                        <strong>Technician:</strong>
                                        {{ ticket.repaired_materials[0].technician ? ticket.repaired_materials[0].technician : '-' }}
                                    </p>
                                    <p>
                                        <strong>Call out date:</strong>
                                        {{
                                            ticket.repaired_materials[0].call_out_date
                                                ? readAbleTime(ticket.repaired_materials[0].call_out_date, false)
                                                : '-'
                                        }}
                                    </p>

                                    <template
                                        v-if="
                                            ticket.repaired_materials &&
                                            ticket.repaired_materials.length > 0 &&
                                            ticket.repaired_materials[0].replaced_product_sku
                                        "
                                    >
                                        <p><strong>Repaired materials:</strong></p>
                                        <div class="d-flex flex-wrap">
                                            <p
                                                class="repaired-item mt-2"
                                                v-for="repaired in ticket.repaired_materials"
                                                :key="ticket.id + '_' + repaired.replaced_product_sku"
                                            >
                                                {{ repaired.replaced_product_name }}
                                            </p>
                                        </div>
                                    </template>
                                </div>
                            </li>

                            <li v-else-if="msg.type === 'decline'" class="chat-closed">
                                <div>Ticket declined at {{ readAbleTime(msg.created_at) }} by {{ msg.by_user_name }}</div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <div class="ticket-wrapper mt-3">
                        <template v-if="getUserRole === 'superadmin' || getUserRole == 'distributor'">
                            <p v-if="ticket_status == '' || ticket_status == 'closed'"><strong>Create ticket on behalf of customer.</strong></p>
                        </template>
                        <template v-else>
                            <h3>SUBMIT A {{ type === 'repair' ? 'REPAIR REQUEST' : ' WARRANTY CLAIM' }}</h3>
                        </template>

                        <div
                            class="alert alert-info"
                            role="alert"
                            v-if="ticket_status == 'request' && (getUserRole === 'reseller' || getUserRole == 'customer')"
                        >
                            <strong>Your request has been received and will be processed as soon as possible.</strong>
                        </div>

                        <div class="ticket-chat-box relative" v-else>
                            <p class="pt-3 mb-2">
                                {{ ticket_status == '' || ticket_status == 'closed' ? 'Select request type:' : 'Message:' }}
                            </p>

                            <div class="radio-button-custom d-flex pb-3" v-if="ticket_status == '' || ticket_status == 'closed'">
                                <label class="radio-form-control d-flex mr-4 cursor-pointer">
                                    <input type="radio" name="radio" class="mr-2" value="warranty" v-model="type" />
                                    <span>Warranty claim</span>
                                </label>

                                <label class="radio-form-control d-flex cursor-pointer">
                                    <input type="radio" name="radio" class="mr-2" value="repair" v-model="type" />
                                    <span>Repair</span>
                                </label>
                            </div>

                            <uploading v-if="sendingTextMessage" />
                            <textarea v-model="message" :placeholder="'Please write your message.'"></textarea>

                            <div class="ticket-attachment-area">
                                <div>
                                    <p class="em-note">Supported png / jpeg / gif / pdf, max size: 10MB</p>
                                    <label for="messageAttachment" class="attachment-label" v-if="attachment.url == ''">
                                        <input
                                            type="file"
                                            style="display: none"
                                            ref="attachment"
                                            @change="fileChange"
                                            name="messageAttachment"
                                            id="messageAttachment"
                                        />
                                        <span><i class="fa fa-paperclip" aria-hidden="true"></i> ADD VIDEO / IMAGE / PDF</span>
                                    </label>
                                </div>

                                <div class="uploading-alert relative">
                                    <div class="overlay-uploading-box" v-if="uploading_file">
                                        <loading />
                                    </div>
                                    <div
                                        class="image-attachment-overview"
                                        v-if="attachment.display_type == 'application/pdf' || attachment.display_type == 'pdf'"
                                    >
                                        <h5>Preview</h5>
                                        <p><em>You won't be able to delete attachment once uploaded.</em></p>
                                        <embed width="100%" height="300px" :src="attachment.url" class="embed-pdf" />
                                    </div>

                                    <template v-if="attachment.attachment_type == 'video/mp4'">
                                        <div class="chat-video">
                                            <video class="video-attachment" controls>
                                                <source :src="msg.attachment_url" type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </template>

                                    <div
                                        class="image-attachment-overview"
                                        v-if="
                                            attachment.display_type == 'image/jpeg' ||
                                            attachment.display_type == 'image/png' ||
                                            attachment.display_type == 'image/jpg' ||
                                            attachment.display_type == 'image/jpeg' ||
                                            attachment.display_type == 'image'
                                        "
                                    >
                                        <h5>Preview</h5>
                                        <p><em>You won't be able to delete attachment once uploaded.</em></p>
                                        <img height="300px" v-if="attachment.url" :src="attachment.url" />
                                    </div>
                                    <div class="image-attachment-overview video-type" v-if="attachment.display_type == 'video'">
                                        <h5>Preview</h5>
                                        <p><em>You won't be able to delete attachment once uploaded.</em></p>
                                        <video width="100%" height="300px" controls>
                                            <source :src="attachment.url" id="video_here" />
                                            Your browser does not support HTML5 video.
                                        </video>
                                    </div>
                                </div>

                                <div class="attachment-action-buttons" v-if="attachment.url && uploading_file == false">
                                    <button type="button" class="btn btn-primary" @click.prevent="resetAttachment()">
                                        <i class="fas fa-times"></i> REMOVE ATTACHMENT
                                    </button>
                                </div>
                            </div>

                            <template v-if="getUserRole === 'superadmin' || getUserRole === 'distributor'">
                                <div class="close-ticket-wrap" v-if="ticket_status == 'open'">
                                    <div class="radio-button-custom d-flex pb-3">
                                        <label class="radio-form-control d-flex mr-4 cursor-pointer">
                                            <input type="checkbox" name="close_ticket" class="mr-2" value="1" v-model="close_ticket" />
                                            <span>Close ticket</span>
                                        </label>
                                    </div>
                                </div>
                            </template>

                            <div
                                v-if="(getUserRole === 'superadmin' || getUserRole == 'distributor') && close_ticket"
                                class="repaired-materials-wrapper mb-3"
                            >
                                <div class="mb-3">
                                    <span class="semibold text-white">Job card:</span>
                                    <span>
                                        <div class="warantefile mt-1">
                                            <label for="jobCard" :class="'file-uploader white mb-0 ' + (job_card.url ? 'has-file' : '')">
                                                <input type="file" ref="jobCard" @change="jobCardChanged" name="jobCard" id="jobCard" />
                                                <i v-if="job_card.url" class="fas fa-file-pdf"></i>
                                                <i v-else class="fas fa-upload"></i>
                                            </label>
                                        </div>
                                    </span>
                                </div>

                                <div class="mb-3">
                                    <span class="semibold text-white">Technician:</span>
                                    <span>
                                        <input
                                            type="text"
                                            name="technician_name"
                                            v-model="repaired.technician"
                                            class="form-control"
                                            placeholder="Technician name"
                                    /></span>
                                </div>

                                <div class="mb-3">
                                    <span class="semibold text-white">Call out date:</span>
                                    <span>
                                        <vuejs-datepicker
                                            initial-view="year"
                                            maximum-view="year"
                                            v-model="repaired.call_out_date"
                                            :typeable="false"
                                            :full-month-name="true"
                                            :format="'yyyy-MM-dd'"
                                            class="input full-width-default"
                                            id="install_date"
                                            placeholder="YYYY-MM-DD"
                                            :disabled-dates="{from: new Date()}"
                                        ></vuejs-datepicker>
                                    </span>
                                </div>

                                <div>
                                    <label class="text-white mb-0">Repaired materials</label>
                                    <multiselect
                                        mode="tags"
                                        openDirection="top"
                                        :searchable="true"
                                        v-model="repaired.repaired_materials"
                                        :options="repaired_materials_options"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select repaired materials"
                                        label="name"
                                        track-by="value"
                                        :preselect-first="false"
                                    />
                                </div>
                            </div>

                            <div class="text-right">
                                <button type="button" class="btn btn-primary" @click.prevent="sending_message ? void 0 : submitTicketMessage()">
                                    {{ sending_message ? 'SENDING...' : 'SEND' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-modal :class="'ticket-image-modal'" :active="imageModal.active" :callback="closeImageModal">
            <div class="custom-modal-content" slot="content">
                <div class="modal-action-wrapper">
                    <div class="chat-image-modal">
                        <img v-if="imageModal.url" :src="imageModal.url" alt="" />
                    </div>
                </div>
            </div>
        </app-modal>
    </div>
</template>
<script>
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js';
import '@vueform/multiselect/themes/default.css';
import {mapGetters} from 'vuex';
import moment from 'moment';
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import Uploading from './Uploading';
import bus from '@/bus';

export default {
    name: 'ticketBox',
    props: {
        ticket_status: String,
        ticket_type: String,
        tickets: {type: Array},
        form: {type: Object}
    },
    components: {
        Uploading,
        Multiselect
    },

    data() {
        return {
            repaired_materials_options: [],
            repaired: {
                technician: '',
                call_out_date: '',
                repaired_materials: []
            },
            job_card: {
                url: '',
                file: '',
                name: '',
                type: '',
                size: ''
            },

            value: null,
            sending_message: false,
            sendingTextMessage: false,
            imageModal: {
                url: '',
                active: false
            },
            uploading_file: false,
            has_open_ticket: false,

            close_ticket: false,
            message: '',
            has_attachment: false,
            type: 'warranty',
            attachment: {
                url: '',
                file: '',
                display_type: '',
                data: '',
                name: '',
                type: '',
                size: ''
            }
        };
    },
    computed: {
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid',
            vg_loggedIn_user: 'auth/user'
        }),
        getUserRole() {
            return this.vg_loggedIn_user.role;
        }
    },
    mounted() {
        this.fetchRepairMaterails();

        this.has_open_ticket = this.form.has_open_ticket;
        bus.$on('ticket-box-reset', () => {
            (this.message = ''),
                (this.has_attachment = false),
                (this.attachment = {
                    url: '',
                    file: '',
                    display_type: '',
                    data: '',
                    name: '',
                    type: '',
                    size: ''
                });
        });
        if (this.tickets.length > 0) {
            let objDiv = document.getElementById('display_messages');
            objDiv.scrollTop = objDiv.scrollHeight;
        }
    },
    methods: {
        nameWithLang({name, language}) {
            return `${name} — [${language}]`;
        },
        openImageModal(url) {
            this.imageModal = {
                active: true,
                url
            };
        },
        closeImageModal() {
            this.imageModal = {
                active: false,
                url: ''
            };
        },

        /**
         * Ticket message
         */
        submitTicketMessage() {
            if (this.message == '') {
                return this.$toasted.global.error({
                    message: 'Please type in some message.'
                });
            }
            // create
            let url = `${Env.baseUrl}/v2/ticket/create/${this.$route.params.id}`;
            if (this.ticket_status === 'open') {
                // add message
                url = `${Env.baseUrl}/v2/ticket/add-message/${this.$route.params.id}`;
                // open but now going to close
                if (this.close_ticket) {
                    url = `${Env.baseUrl}/v2/ticket/close/${this.$route.params.id}`;
                }
            }

            let formData = new FormData();
            formData.append('message', this.message);

            if (this.ticket_status == '' || this.ticket_status == 'closed') {
                // to create new tickets only we allow
                formData.append('ticket_type', this.type);
            }

            if (this.close_ticket) {
                // all fields are mandatory
                if (!this.job_card.file) {
                    return this.$toasted.global.error({
                        message: 'Please fill in job card.'
                    });
                }
                if (!this.repaired.technician) {
                    return this.$toasted.global.error({
                        message: 'Please fill technician name.'
                    });
                }
                if (!this.repaired.call_out_date) {
                    return this.$toasted.global.error({
                        message: 'Please fill in call out date.'
                    });
                }

                if (this.job_card.file) {
                    formData.append('job_card', this.job_card.file);
                }
                formData.append('technician', this.repaired.technician);
                if (this.repaired.call_out_date) {
                    formData.append('call_out_date', moment(this.repaired.call_out_date).format('YYYY-MM-DD'));
                }

                if (this.repaired.repaired_materials.length > 0) {
                    // Attach repaired materials
                    formData.append('repaired_materials', this.repaired.repaired_materials);
                }
            }

            if (this.attachment.file) {
                formData.append('attachment', this.attachment.file);
                formData.append('attachment_type', this.attachment.type);
            }

            this.sending_message = true;
            this.spinner(true);
            AuthApis.postApi(url, formData)
                .then((res) => {
                    // Emit to distributor
                    // if(this.vg_loggedIn_user.role == 'distributor'){
                    //   bus.$emit('distributor-refetch-product-detail')
                    // }
                    this.message = '';
                    this.sending_message = false;
                    this.spinner(false);
                    //  this.sendingTextMessage = false;
                    this.$toasted.global.success({
                        message: 'Message sent successfully'
                    });
                    if (this.ticket_status == '' || this.ticket_status == 'closed' || this.close_ticket == true) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1500);
                    } else {
                        this.sending_message = false;
                        this.sendingTextMessage = false;
                        this.message = '';
                        this.resetAttachment();
                        bus.$emit('warranty-repair-box-refetch');
                    }
                })
                .catch((err) => {
                    this.spinner(false);
                    this.sendingTextMessage = false;
                    this.sending_message = false;
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         * Repair materials
         */
        fetchRepairMaterails() {
            let url = `${Env.baseUrl}/auth/repaired-materials-list`;
            AuthApis.postApi(url, {
                sku: this.form.sku_number
            })
                .then((res) => {
                    if (res.status == 200) {
                        // here we get in key and value pair

                        this.repaired_materials_options = Object.entries(res.data.payload).map(([key, value]) => ({
                            name: value,
                            value: key
                        }));
                    }
                })
                .catch(() => {});
        },

        /**
         * reset attachmebnt
         */
        resetAttachment() {
            if (document.getElementById('messageAttachment')) {
                document.getElementById('messageAttachment').value = '';
            }
            this.attachment = {
                url: '',
                display_type: '',
                file: '',
                data: '',
                name: '',
                type: '',
                size: ''
            };
        },

        /**
         * Cancel request
         */
        cancelAttachmentUpload() {
            this.cancelToken.cancel();
        },

        readAbleTime(str, hhmmaa = true) {
            return hhmmaa ? moment(str).format('YYYY-MM-DD hh:mm a') : moment(str).format('YYYY-MM-DD');
        },

        /**
         * Fle handling
         */
        async fileChange(e) {
            let display_type = '';
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            // file type cehck
            let acceptFile = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png', 'video/mp4'];
            if (acceptFile.indexOf(this.$refs.attachment.files[0].type) == -1) {
                document.getElementById('messageAttachment').value = '';
                this.$toasted.global.error({
                    message: 'Sorry only pdf, jpg, jepg, png, mp4 files are allowed.'
                });
                return;
            }

            // filesize prevent
            let pic_limit_5Mb = 10 * 1000000; // 10 MB limit
            let vid_limit_100Mb = 200 * 1000000; // 100 MB limit
            if (this.$refs.attachment.files[0].type == 'video/mp4') {
                display_type = 'video';
                if (this.$refs.attachment.files[0].size > vid_limit_100Mb) {
                    document.getElementById('messageAttachment').value = '';
                    this.$toasted.global.error({
                        message: 'Sorry video file cannot be more than 100MB.'
                    });
                    return;
                }
            } else if (this.$refs.attachment.files[0].type == 'application/pdf') {
                display_type = 'pdf';
                if (this.$refs.attachment.files[0].size > pic_limit_5Mb) {
                    document.getElementById('messageAttachment').value = '';
                    this.$toasted.global.error({
                        message: 'Sorry Pdf file cannot be more than 10MB.'
                    });
                    return;
                }
            } else {
                display_type = 'image';
                if (this.$refs.attachment.files[0].size > pic_limit_5Mb) {
                    document.getElementById('messageAttachment').value = '';
                    this.$toasted.global.error({
                        message: 'Sorry image file cannot be more than 10MB.'
                    });
                    return;
                }
            }
            this.has_attachment = true;
            this.attachment = {
                url: URL.createObjectURL(files[0]),
                display_type: display_type,
                file: files[0],
                name: this.$refs.attachment.files[0].name,
                type: this.$refs.attachment.files[0].type,
                size: this.$refs.attachment.files[0].size
            };
        },

        /**
         * Job card changed
         */

        async jobCardChanged(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }

            // file type cehck
            if (this.$refs.jobCard.files[0].type != 'application/pdf') {
                document.getElementById('jobCard').value = '';
                this.$toasted.global.error({
                    message: 'Only pdf files are allowed.'
                });
                return;
            }

            // filesize prevent
            let limit5Mb = 10 * 1000000; // 5 MB limit
            if (this.$refs.jobCard.files[0].size > limit5Mb) {
                document.getElementById('jobCard').value = '';
                this.snackbar({
                    message: 'Sorry file cannot be more than 10MB.',
                    type: 'warning'
                });
                return;
            }

            this.job_card = {
                url: URL.createObjectURL(files[0]),
                file: files[0],
                name: this.$refs.jobCard.files[0].name,
                type: this.$refs.jobCard.files[0].type,
                size: this.$refs.jobCard.files[0].size
            };
        },

        async updateAction(action) {
            this.spinner(true);
            let url = `${Env.baseUrl}/v2/ticket/update-status/${this.$route.params.id}`;
            AuthApis.postApi(url, {action})
                .then((res) => {
                    this.spinner(false);
                    window.location.reload();
                })
                .catch(() => {
                    this.spinner(false);
                });
        }
    }
};
</script>
